// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"f1","rentalBadge":"f2","videoWrapper":"f3","videoBottomGradient":"f4","videoLeftGradient":"f5"};